export default () => {
  return <div>404</div>;
};
